"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { formatCountdown } from "@/utils/timeFormatters";

/**
 * Hook that provides auto-updating countdown text
 * @param targetTime Future timestamp in milliseconds or null
 * @returns Formatted string that updates periodically
 */
export function useCountdown(targetTime) {
  const $ = _c(5);
  let t0;
  if ($[0] !== targetTime) {
    t0 = () => formatCountdown(targetTime);
    $[0] = targetTime;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [display, setDisplay] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== targetTime) {
    t1 = () => {
      if (!targetTime) {
        setDisplay("");
        return;
      }
      const updateDisplay = function updateDisplay() {
        const formatted = formatCountdown(targetTime);
        setDisplay(formatted);
        return targetTime !== null && Date.now() < targetTime;
      };
      const getUpdateInterval = function getUpdateInterval() {
        const timeRemaining = targetTime !== null ? targetTime - Date.now() : 0;
        if (timeRemaining < 3600000) {
          return 60000;
        } else {
          if (timeRemaining < 86400000) {
            return 300000;
          } else {
            return 3600000;
          }
        }
      };
      updateDisplay();
      const intervalTime = getUpdateInterval();
      const interval = setInterval(() => {
        const shouldContinue = updateDisplay();
        if (!shouldContinue) {
          clearInterval(interval);
        }
      }, intervalTime);
      return () => clearInterval(interval);
    };
    t2 = [targetTime];
    $[2] = targetTime;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return display;
}